// sections/TrainerSection.jsx
import React, { useMemo } from 'react';
import MenuItem from '@mui/material/MenuItem';
import MDSelect from 'components/MDSelect';
import { Section } from './Section';

export function TrainerSection({ sx, tokens, trainerId, setTrainerId, trainers, loading, error }) {
  const list = Array.isArray(trainers) ? trainers : [];

  const selectedLabel = useMemo(() => {
    if (!trainerId) return '';
    const found = list.find((t) => String(t.id) === String(trainerId));
    return found?.name || `#${trainerId}`; // ✅ listede yoksa bile görünür
  }, [list, trainerId]);

  return (
    <Section title="Eğitmen" icon="person" sx={sx}>
      <MDSelect
        value={trainerId || ''}
        onChange={(e) => setTrainerId(String(e.target.value))}
        fullWidth
        displayEmpty
        sx={tokens.select}
        disabled={loading || error}
        // ✅ Seçili değer: ID değil, isim görünsün
        renderValue={(val) => {
          if (!val) return <em>Eğitmen seç</em>;
          return selectedLabel || <em>Eğitmen seç</em>;
        }}
      >
        {/* ✅ placeholder */}
        <MenuItem value="">
          <em>Eğitmen seç</em>
        </MenuItem>

        {loading ? (
          <MenuItem value="" disabled>
            <em>Eğitmenlar yükleniyor…</em>
          </MenuItem>
        ) : error ? (
          <MenuItem value="" disabled>
            <em>Eğitmenlar yüklenemedi</em>
          </MenuItem>
        ) : (
          list.map((t) => (
            <MenuItem key={t.id} value={String(t.id)}>
              {t.name}
            </MenuItem>
          ))
        )}
      </MDSelect>
    </Section>
  );
}
